import MainUtils from '@/utils/MainUtils';

class RangersLogUtils {
  /**
   * 火山AB测试
   * 3.9.51
   * @param key： AB测试名
   * @param defaultValue：默认组名
   * */
  static getABTestConfigValueForKey = (key: string, defaultValue: string): Promise<any> =>
    new Promise((resolve, reject) => {
      try {
        if (MainUtils.isInApp('3.9.51')) {
          (window as any).api.abTestRangersFun(
            {
              key: key ?? '',
              defaultValue: defaultValue ?? 'default',
            },
            (ret: any, err: any) => {
              if (ret !== null) {
                resolve(ret);
              } else {
                reject(err);
              }
            },
          );
        } else {
          resolve(defaultValue);
        }
      } catch (error) {
        resolve(defaultValue);
      }
    });
}

export default RangersLogUtils;
